<template>
  <div style="margin-top:20px">
    <div style="width: 100%; background-color: #eee; border: 1px dotted grey; margin-bottom: 25px;">
      <span style="font-size: 26px; font-weight: bold">Route Addresses</span><br/>
      <span style="font-style: italic; font-size: 18px">View addresses for your recent routes (address names in <span style="color: green">green</span> match a Samsara address)</span>
    </div>

    <div style="font-size: 22px; font-weight: bold; margin-top: 25px; position: relative" class="align-right d-flex align-items-center justify-content-center">
        <span v-if="route_groups.length > 0">
        Select Route Group:
          &nbsp;<b-form-select v-model="route_group" :options="route_groups" style="font-size: 18px; font-weight: bold; width:200px"/>
        </span>
      <span v-if="route_options.length > 0">
        &nbsp;&nbsp;|&nbsp;&nbsp;Select Route:
          &nbsp;<b-form-select v-model="route_filter" :options="route_options" style="font-size: 18px; font-weight: bold; width:250px"/>
        </span>
      &nbsp;&nbsp;<b-button size="md" @click="load_data()">Search</b-button>
      &nbsp;&nbsp;|&nbsp;&nbsp;<b-button size="md" @click="reset()">Reset</b-button>
    </div>
    <br/>

    <div v-if="!loading">
      <div v-if="items.length > 0" ref="test" class="row" style="margin: 0px">
        <div class="col" style="overflow-y:scroll; max-height: 900px; min-width: 480px; max-width: 500px">
          <br/>
          <div style="font-weight: bold; font-size: 22px; color: steelblue; margin-bottom: 10px;">{{items.length}} Addresses Found</div>

          <div class="route-item" v-for="item in items" style="text-align: left; padding:8px; border-top: 1px solid black;">
            <div :style="item.selected ? 'background-color: #E6E7E9; padding: 2px 5px 2px 5px': ''">
              <span v-on:click="show_address(item)" >
                <span v-if="item.id" style="font-size: 16px; font-weight: bold; color: green">{{item.name | trim(50)}}</span>
                <span v-else style="font-size: 16px; font-weight: bold;">{{item.name | trim(50)}}</span>
              </span>
              <div v-if="item.selected">
                <span v-for="route in item.routes.split(',')">
                  <b-button variant="info" size="sm" @click="route_filter=route" style="margin: 3px">{{route}}</b-button>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div class="col" style="border: none; padding-right:0px !important; padding-left:0px !important">
          <GmapMap id="map" ref="mapRef"
                   :zoom="zoom"
                   :center="center"
                   :options="mapStyle"
                   style="width:100%;  height: 900px;"
          >
          </GmapMap>
        </div>
      </div>
    </div>
    <div v-if="loading">
      <br/><br/>
      <b-spinner style="width: 3rem; height: 3rem;" label="Loading..."></b-spinner>
    </div>
  </div>

</template>

<script>

import {get_route_addresses, get_route_names, get_route_patterns} from '../networking/apis'
import {mapState} from "vuex";
import moment from "moment";
import {justDate} from "../helpers/dates";

    export default {
      name: 'route_addresses',
      components: {
      },

      data() {
        return {
          toggle: {},
          file: null,
          details_fromDate: justDate(moment().subtract(1, 'days')),
          items: [],
          route_groups: [],
          route_options: [],
          route_group: '',
          route_filter: '',
          summary: [],
          center: null,
          zoom: null,
          markers: [],
          markers_full: [],
          shapes: [],
          shapes_full: [],
          loading: false,
          totalRows: 1,
          currentPage: 1,
          perPage: 400,
          pages: [],
          fields: [
            {key: 'address', sortable: true},
          ],
          mapStyle: {
            styles: [
              {
                "featureType": "landscape",
                "stylers": [
                  {"color": "#F3F4F9"}
                ]
              }, {
                "featureType": "water",
                "stylers": [
                  {"color": "#C1CDE4"}
                ]
              },
              {
                "featureType": "landscape.natural.terrain",
                "stylers": [
                  {"color": "#E0EDCA"}
                ]
              },
              {
                featureType: 'road',
                elementType: 'geometry.stroke',
                stylers: [{color: '#DDDDDD'}]
              },
              {
                featureType: 'road',
                elementType: 'geometry.fill',
                stylers: [{color: '#FFFFFF'}]
              },
              {
                featureType: 'road.highway',
                elementType: 'geometry.fill',
                stylers: [{color: '#FEF8D6'}]
              },
              {
                featureType: 'transit',
                stylers: [{"visibility": "off"}]
              },
              {
                featureType: 'poi',
                stylers: [{"visibility": "off"}]
              },
            ]
          }
        }
      },

      async created() {
        await this.check_features()
      },
      methods: {
        async reset() {
          this.summary = null
          this.items = []
          this.markers = []
          this.shapes = []
          this.route_group = ''
          this.route_filter = ''
          this.route_options = []
          await this.load_data()
        },
        async check_features() {
          this.summary = null
          this.items = []
          this.markers = []
          this.shapes = []
          this.route_group = ''
          this.route_filter = ''
          this.route_options = []
          this.route_groups = []
          await this.load_route_groups()

          if (this.$route.query.routeName) {
            this.route_filter = this.$route.query.routeName
          }

          await this.load_data()

          if (this.$route.query.address) {
            this.items = this.items.filter(item => item.name == this.$route.query.address)
            this.show_address(this.items[0])
          }

        },
        async load_route_groups() {
          const {value: {data = []}} = await get_route_patterns(this.user.tenant, moment(this.details_fromDate, 'MM-DD-YYYY').format('YYYY-MM-DD'))
          this.route_groups = data
        },
        show_address(address) {
          address['selected'] = !address['selected'];

          if (address['selected']) {

            this.center = {
              lat: Number(address.lat),
              lng: Number(address.lng),
            };

            for (const shape of this.shapes) {
              if (shape.title != address.name)
                shape.setMap(null);
              else
                shape.setMap(this.$refs.mapRef.$mapObject);
            }

            this.zoom = 16

          } else {
            for (const shape of this.shapes) {
              shape.setMap(this.$refs.mapRef.$mapObject);
            }
            this.zoom = 13
          }
          this.$forceUpdate();
        },
        sleep(ms) {
          return new Promise(resolve => setTimeout(resolve, ms));
        },
        async load_data() {
          this.loading = true
          try {
            const {value: { data = [] } } = await get_route_addresses(this.user.tenant, this.route_group, this.route_filter)
            this.items = data.results
            this.summary = data.summary
            if (this.route_options.length === 0)
              this.route_options = data.summary.route_options

            moment.tz.setDefault(this.summary.timezone)
            this.zoom = 10

            this.center = {
              lat: Number(this.items[0].lat),
              lng: Number(this.items[0].lng),
            };

            this.loading = false

            await this.addGeofences()
            //await this.addDrawingManager()

          } catch(e) {
            this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed: ' +e, 'danger', 5000)
          }
        },
        async addDrawingManager() {

          if (!this.$refs.mapRef) {
            while(true) {
              if (this.$refs.mapRef && this.$refs.mapRef.$mapCreated)
                break;
              await this.sleep(500);
              console.log("waiting for mapref")
            }
          }

          const drawingManager = new google.maps.drawing.DrawingManager({
            drawingMode: google.maps.drawing.OverlayType.MARKER,
            drawingControl: true,
            drawingControlOptions: {
              position: google.maps.ControlPosition.TOP_CENTER,
              drawingModes: [
                google.maps.drawing.OverlayType.CIRCLE,
                google.maps.drawing.OverlayType.POLYGON,
                google.maps.drawing.OverlayType.RECTANGLE
              ],
            },
            circleOptions: {
              fillColor: "steelblue",
              fillOpacity: .5,
              strokeWeight: 5,
              clickable: false,
              editable: true,
              zIndex: 1,
            },
            polygonOptions: {
              clickable: true,
              draggable: true,
              editable: true,
              fillOpacity: .5,
              fillColor: "steelblue"
            }
          });
          drawingManager.setMap(this.$refs.mapRef);
        },
        async addGeofences() {

          if (!this.$refs.mapRef) {
            while(true) {
              if (this.$refs.mapRef)
                break;
              await this.sleep(500);
              console.log("waiting for mapref")
            }
          }

          if (this.$refs.mapRef) {
            for (const address of this.items) {

              if (address.type == 'circle') {

                const fill_color = "#458FE5";

                let shape = new google.maps.Circle({
                  title: address.name,
                  strokeColor: "#458FE5",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: fill_color,
                  fillOpacity: 0.1,
                  map: this.$refs.mapRef.$mapObject,
                  center: {lat: address.lat, lng: address.lng},
                  radius: address.radius,
                });

                // var infoWindow = new google.maps.InfoWindow({
                //   content: "<div>Hello! World</div>",
                //   maxWidth: 500
                // });
                //
                // google.maps.event.addListener(shape, 'click', function(ev) {
                //   infoWindow.setPosition(ev.latLng);
                //   infoWindow.open(map);
                // });

                this.shapes.push(shape);
              } else {
                let shape = new google.maps.Polygon({
                  title: address.name,
                  paths: address.vertices,
                  strokeColor: "#458FE5",
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: "#458FE5",
                  fillOpacity: 0.1,
                  map: this.$refs.mapRef.$mapObject,
                });
                this.shapes.push(shape);
              }
            }
          }
          this.$forceUpdate();
        },
      },

      computed:{
        ...mapState({
          user: state => state.profile.user
        }),
      },
      watch: {
        user: {
          deep: true,
          handler() {
            this.check_features()
          }
        },
        route_group() {
          if (this.route_group != '')
            this.route_filter = '';
        },
        route_filter() {
          if (this.route_filter != '')
            this.route_group = '';
        }
      }
    }
</script>

<style>
  .error td { background-color: rgba(255,0,0,0.25)}
  .success td {background-color: hsla(120,100%,75%,0.3)}
  .unprocessed td { background-color: hsla(200,40%,80%,0.3) }
  .cancelled td { background-color: hsla(290,60%,70%,0.3) }

  div.row:nth-child(even) {
    background-color: #f2f2f2;
  }

  tr:nth-child(even) {
    background-color: #f2f2f2;
  }

  .header {
    font-weight: bold;
  }

  div.col {
    border: 1px solid grey;
  }

  .table td {
    padding: .1rem !important;
  }

  .list-text {
    text-align: left;
    margin-top: 7px;
    margin-left: 7px;
  }

  .list-option {
    text-align: left;
    margin: 2px;
  }
</style>

